import _ from "lodash";
import { Definition, Property } from "../../../data/Definition";
import DwQueryClient from "../../../data/DwQueryClient";
import { DwQuery } from "../../../data/Query";
import { EntityTimeSeriesResults, TimeSeriesStatQueryConfig } from "../types/types";
import { landscan_rows_constraint } from "../../../__generated__/types";

const metricLut = {
    'variability': {
        propLut: ['vvic'],
        filterMinValue: 12000,
        filterMaxValue: undefined,
        invertGood: false,
        transform: (values: number[]): number[] | null => {
            //console.log("B053124 values", values);
            const scale = 1 / (20000-12000);
            return !values ? null : values.map((v: number) => {
                //console.log("B053124 v", v);
                return (v) * scale * 100;
            });
        }
    },
    'variability_change': {
        propLut: ['vvic'],
        filterMinValue: 12000,
        filterMaxValue: undefined,
        invertGood: false,
        transform: (values: number[]): number[] | null => {
            //console.log("B053124 values", values);
            const scale = 1 / (20000-12000);
            return !values ? null : values.map((v: number) => {
                //console.log("B053124 v", v);
                return (v) * scale * 100;
            });
        }
    },
    'productivity': {
        propLut: ['vvic'],
        filterMinValue: 12000,
        filterMaxValue: undefined,
        invertGood: false,
        transform: (values: number[]): number[] => {
            const scale = 1 / (20000-12000);
            console.log("B051524 values", values);
            return values.map((v: number) => {
                return (v-12000) * scale * 100;
            });
        }
    },
    'stress': {
        propLut: ['pgi'],
        filterMinValue: 100,
        filterMaxValue: 200,
        invertGood: true,
        transform: (values: number[], row:any, caller:string): number[] => { // transforms for the sparkline widgets on (fields) 2nd col and (zones) BB card 
            //console.log("AA051624 ----------------------------------------------");
            //console.log("AA051624 values", values);
            //console.log("AA051624 row", row);
            //console.log("AA051624 caller", caller);
            let maxValue:number;
            if (caller === 'fields') {
                console.log("AA051624 fields", caller);
                maxValue = Math.max(...values);
            }else{ // for zones, we need to use the max value of all zones (the entire field)
                let maxValues:any = [];
                row.forEach((zone:any) => {
                    //console.log("AA051624 zone", zone);
                    maxValues.push(Math.max(...zone.stress_mean));
                })
                maxValue = Math.max(...maxValues);
            }
            console.log("AA051624 maxValue", maxValue);
            //const range  = maxValue - 100;
            const minValue = 100;
            //console.log("A031924 range", range);
            return values.map((v: number) => {
                //console.log("AA051624 v", v);
                //console.log("AA051624 maxValue - v / ( maxValue - minValue )", (maxValue - v) / ( maxValue - minValue ) * 100);
                return (maxValue - v) / ( maxValue - minValue ) * 100
                //return 100 - ((maxValue - v) / range * 100);
            });
        }
    }
};

export const queryDwLayerCanopyPropertyData = async (extId: number, definition: Definition, metric: string, dtStart: string, dtEnd: string, dwFilters:any) => {
    // find the metric in the definition
    //const property = getProperty(definition, metricLut[metric].propLut);

    //if(!property) {
    //    return null;
    //}
    //console.log("metric", metric)
    const options = metricLut[metric];
    // create the time series query
    let query = new DwQuery(definition.id!, definition.name, definition.feature);
    //query.timeSeries = true;
    //query.dimensions = [];
    // dimensions
    query.addDimension({
        type: "entity",
        id: `${definition.name}:${definition.name}`,
        name: definition.name,
        bin: null
    });
    const ca = getProperty(definition, ['canopyarea'])
    query.addMeasure({
        type: "property",
        id: `${definition.name}:${ca?.id}`,
        name: ca?.property ? ca?.property : "canopyarea",
        aggregation: "max"
    });
    const cv = getProperty(definition, ['canopyvolume'])
    query.addMeasure({
        type: "property",
        id: `${definition.name}:${cv?.id}`,
        name: cv?.property ? cv?.property : "canopyvolume",
        aggregation: "max"
    });
    query.addFilter({
        type: "entity",
        id: `${definition.name}:field`,
        name: "field",
        operation: "eq",
        value: `${extId}`
    });
    const ca_filter = getProperty(definition, ['canopyarea'])
    query.addFilter({
        "type": "property",
        "id": `${definition.name}:${ca_filter?.id}[date]`,
        "name": ca_filter?.property ? ca_filter?.property : "canopyarea",
        "operation": "between",
        "value": [
            dtStart,
            dtEnd
        ]
    });
    
    // send query to dw
    const dwResults = await queryDwData(query);
    if(!dwResults) {
        return null;
    }
    const objResults = {};
    dwResults.forEach((accumulator:any) => {
        return objResults[accumulator[`${definition.name ? definition.name : 'plant' }_id`]] = accumulator;
      }, {});
    //console.log("Query xx objResults ", objResults )
    // transform data
    return objResults; //await parseDwResults(_plantprofileId, metric, dwResults);
}

function capitalizeFirstLetter(str: string) {
    if (typeof str !== "string" || str.length === 0) {
      return str; // Return the original string if it's not a string or is an empty string.
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export const queryDwLayerRowCol = async (extId: number, definition: Definition, metric: string, dtStart: string, dtEnd: string, dwFilters:any) => {

    const options = metricLut[metric];
    // create the query
    let query = new DwQuery(definition.id!, definition.name, definition.feature);
   
    query.addDimension({
        type: "entity",
        id: `${definition.name}:${definition.name}`,
        name: definition.name,
        bin: null
    });
    console.log("041823 definition", definition)
    const r = getProperty(definition, ['row'])
    if (r){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${r?.id}`,
            "name": r?.property ? r?.property : "row"
        });
    }
    const p = getProperty(definition, ['plant'])
    if (p){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${p?.id}`,
            "name": capitalizeFirstLetter(p.property ? p.property : "plant") // For this special case, plant must be capitalized to differentiate it from the plant name
        });
    }
    query.addFilter({
        type: "entity",
        id: `${definition.name}:field`,
        name: "field",
        operation: "eq",
        value: `${extId}`
    });
    
    // send query to dw
    const dwResults = await queryDwData(query);
    if(!dwResults) {
        return null;
    }
    const objResults = {};
    dwResults.forEach((accumulator:any) => {
        return objResults[accumulator[`${definition.name ? definition.name : 'plant' }_id`]] = accumulator;
      }, {});
    //console.log("Query xx objResults ", objResults )
    // transform data
    return objResults; //await parseDwResults(_plantprofileId, metric, dwResults);
}

export const queryDwLayerTreatmentPropertyData = async (extId: number, definition: Definition, metric: string, dtStart: string, dtEnd: string, dwFilters:any) => {
    // find the metric in the definition
    //const property = getProperty(definition, metricLut[metric].propLut);
    console.log("X022823 Query xx queryDwLayerTreatmentPropertyData definition", definition);
    //if(!property) {
    //    return null;
    //}
    //console.log("metric", metric)
    const options = metricLut[metric];
    // create the time series query
    let query = new DwQuery(definition.id!, definition.name, definition.feature);
    //query.timeSeries = true;
    //query.dimensions = [];
    // dimensions
    query.addDimension({
        type: "entity",
        id: `${definition.name}:${definition.name}`,
        name: definition.name,
        bin: null
    });
    /*const bI = getProperty(definition, ['bloom index']);
    query.addMeasure({
        type: "property",
        id: `${definition.name}:${bI?.id}`,
        name: bI?.property ? bI?.property : "bloom index",
        aggregation: "max"
    });*/
    const tC = getProperty(definition, ['treatment color']);
    console.log("B022624 Treatment def - tC", tC)
    if (!tC){
        return null;
    }
    query.addMeasure({
        type: "property",
        id: `${definition.name}:${tC?.id}`,
        name: tC?.property ? tC?.property : "treatment color",
        aggregation: "max"
    });
    query.addFilter({
        type: "entity",
        id: `${definition.name}:field`,
        name: "field",
        operation: "eq",
        value: `${extId}`
    });
    /*query.addFilter({
        "type": "property",
        "id": `${definition.name}:${bI?.id}[date]`,
        "name": bI?.property ? bI?.property : "bloom index",
        "operation": "between",
        "value": [
            dtStart,
            dtEnd
        ]
    });*/
    query.addFilter({
        "type": "property",
        "id": `${definition.name}:${tC?.id}[date]`,
        "name": tC?.property ? tC?.property : "treatment color",
        "operation": "between",
        "value": [
            dtStart,
            dtEnd
        ]
    });
    
    // send query to dw
    const dwResults = await queryDwData(query);
    if(!dwResults) {
        return null;
    }
    const objResults = {};
    dwResults.forEach((accumulator:any) => {
        return objResults[accumulator[`${definition.name ? definition.name : 'plant' }_id`]] = accumulator;
      }, {});
    console.log("ZZ022823 Query xx dwResults ", dwResults )
    console.log("ZZ022823 Query xx objResults ", objResults )
    // transform data
    return objResults; //await parseDwResults(_plantprofileId, metric, dwResults);
}

export const queryDwLayerBloomPropertyData = async (extId: number, definition: Definition, metric: string, dtStart: string, dtEnd: string, dwFilters:any) => {
    // find the metric in the definition
    //const property = getProperty(definition, metricLut[metric].propLut);
    console.log("B021424 Query xx queryDwLayerCultivarPropertyData definition", definition);
    console.log("B021424 dtStart, dtEnd", dtStart, dtEnd);
    //if(!property) {
    //    return null;
    //}
    //console.log("metric", metric)
    const options = metricLut[metric];
    // create the time series query
    let query = new DwQuery(definition.id!, definition.name, definition.feature);
    //query.timeSeries = true;
    //query.dimensions = [];
    // dimensions
    query.addDimension({
        type: "entity",
        id: `${definition.name}:${definition.name}`,
        name: definition.name,
        bin: null
    });
    const bI = getProperty(definition, ['bloom index']);
    if (bI){
        query.addMeasure({
            type: "property",
            id: `${definition.name}:${bI?.id}`,
            name: bI?.property ? bI?.property : "bloom index",
            aggregation: "max"
        });
    }else{
        return null;
    }
    /*const c = getProperty(definition, ['cultivar', 'Cultivar'])
    if (c){
        query.addMeasure({
            type: "property",
            id: `${definition.name}:${c?.id}`,
            name: c?.property ? c?.property : "Cultivar",
            aggregation: "max"
        });
    }*/
    query.addFilter({
        type: "entity",
        id: `${definition.name}:field`,
        name: "field",
        operation: "eq",
        value: `${extId}`
    });
    if (bI){
        query.addFilter({
            "type": "property",
            "id": `${definition.name}:${bI?.id}[date]`,
            "name": bI?.property ? bI?.property : "bloom index",
            "operation": "between",
            "value": [
                dtStart,
                dtEnd
            ]
        });
    }
    
    // send query to dw
    const dwResults = await queryDwData(query);
    if(!dwResults) {
        return null;
    }
    const objResults = {};
    dwResults.forEach((accumulator:any) => {
        return objResults[accumulator[`${definition.name ? definition.name : 'plant' }_id`]] = accumulator;
      }, {});
    console.log("ZZ022823 Query xx dwResults ", dwResults )
    console.log("ZZ022823 Query xx objResults ", objResults )
    // transform data
    return objResults; //await parseDwResults(_plantprofileId, metric, dwResults);
}

export const queryDwLayerStatusData = async (extId: number, definition: Definition, metric: string, dtStart: string, dtEnd: string, dwFilters:any) => {
  
    console.log("X111623 Query xx queryDwLayerStatusData definition", definition);

    let query = new DwQuery(definition.id!, definition.name, definition.feature);

    query.addDimension({
        type: "entity",
        id: `${definition.name}:${definition.name}`,
        name: definition.name,
        bin: null
    });
    const S = getProperty(definition, ['status']);
    if (S){
        query.addMeasure({
            type: "property",
            id: `${definition.name}:${S?.id}`,
            name: S?.property ? S?.property : "status"
        });
    }else{
        return null;
    }
    query.addFilter({
        type: "entity",
        id: `${definition.name}:field`,
        name: "field",
        operation: "eq",
        value: `${extId}`
    });
    
    // send query to dw
    const dwResults = await queryDwData(query);
    if(!dwResults) {
        return null;
    }
    const objResults = {};
    dwResults.forEach((accumulator:any) => {
        return objResults[accumulator[`${definition.name ? definition.name : 'plant' }_id`]] = accumulator;
      }, {});
    console.log("X111623 Query xx dwResults ", dwResults )
    console.log("X111623 Query xx objResults ", objResults )
    // transform data
    return objResults; //await parseDwResults(_plantprofileId, metric, dwResults);
}

export const queryDwLayerCultivarPropertyData = async (extId: number, definition: Definition, metric: string, dtStart: string, dtEnd: string, dwFilters:any) => {

    console.log("X022823 Query xx queryDwLayerCultivarPropertyData definition", definition);

    const options = metricLut[metric];
    // create the time series query
    let query = new DwQuery(definition.id!, definition.name, definition.feature);

    query.addDimension({
        type: "entity",
        id: `${definition.name}:${definition.name}`,
        name: definition.name,
        bin: null
    });

    const cT = getProperty(definition, ['Cultivar']);
    if (cT){
        query.addMeasure({
            type: "property",
            id: `${definition.name}:${cT?.id}`,
            name: cT?.property ? cT?.property : "cultivar",
            // aggregation: "max" // not needed for this type?
        });
    }else{
        return null;
    }
    query.addFilter({
        type: "entity",
        id: `${definition.name}:field`,
        name: "field",
        operation: "eq",
        value: `${extId}`
    });
    /*if (cT){
        query.addFilter({
            "type": "property",
            "id": `${definition.name}:${cT?.id}[date]`,
            "name": cT?.property ? cT?.property : "cultivar",
            "operation": "between",
            "value": [
                dtStart,
                dtEnd
            ]
        });
    }*/
    // send query to dw
    const dwResults = await queryDwData(query);
    if(!dwResults) {
        return null;
    }
    const objResults = {};
    dwResults.forEach((accumulator:any) => {
        return objResults[accumulator[`${definition.name ? definition.name : 'plant' }_id`]] = accumulator;
      }, {});
    console.log("ZZ022823 Query xx dwResults ", dwResults )
    console.log("ZZ022823 Query xx objResults ", objResults )
    // transform data
    return objResults; //await parseDwResults(_plantprofileId, metric, dwResults);
}

export const queryDwLayerVigorPropertyData = async (extId: number, definition: Definition, metric: string, dtStart: string, dtEnd: string, dwFilters:any) => {

    console.log("022124 Query xx queryDwLayerVigorPropertyData definition", definition);

    const options = metricLut[metric];
    // create the time series query
    let query = new DwQuery(definition.id!, definition.name, definition.feature);

    query.addDimension({
        type: "entity",
        id: `${definition.name}:${definition.name}`,
        name: definition.name,
        bin: null
    });

    const vvi = getProperty(definition, ['vvi']);
    if (vvi){
        query.addMeasure({
            type: "property",
            id: `${definition.name}:${vvi?.id}`,
            name: vvi?.property ? vvi?.property : "vvi",
            stat: "mean",
            aggregation: "max"
        });
    }else{
        return null;
    }
    query.addFilter({
        type: "entity",
        id: `${definition.name}:field`,
        name: "field",
        operation: "eq",
        value: `${extId}`
    });
    if (vvi){
        query.addFilter({
            "type": "property",
            "id": `${definition.name}:${vvi?.id}[time]`,
            "name": vvi?.property ? vvi?.property : "vvi",
            "operation": "between",
            "value": [
                dtStart,
                dtEnd
            ]
        });
    }
    // send query to dw
    const dwResults = await queryDwData(query);
    if(!dwResults) {
        return null;
    }
    const objResults = {};
    dwResults.forEach((accumulator:any) => {
        return objResults[accumulator[`${definition.name ? definition.name : 'plant' }_id`]] = accumulator;
      }, {});
    console.log("022124 Query xx dwResults ", dwResults )
    console.log("022124 Query xx objResults ", objResults )
    // transform data
    return objResults; //await parseDwResults(_plantprofileId, metric, dwResults);
}

export const queryDwLayerHeightPropertyData = async (extId: number, definition: Definition, metric: string, dtStart: string, dtEnd: string, dwFilters:any) => {

    console.log("022124 Query xx queryDwLayerHeightPropertyData definition", definition);

    const options = metricLut[metric];
    // create the time series query
    let query = new DwQuery(definition.id!, definition.name, definition.feature);

    query.addDimension({
        type: "entity",
        id: `${definition.name}:${definition.name}`,
        name: definition.name,
        bin: null
    });

    const hT = getProperty(definition, ['height']);
    if (hT){
        query.addMeasure({
            type: "property",
            id: `${definition.name}:${hT?.id}`,
            name: hT?.property ? hT?.property : "height",
            stat: "mean",
            aggregation: "max"
        });
    }else{
        return null;
    }
    query.addFilter({
        type: "entity",
        id: `${definition.name}:field`,
        name: "field",
        operation: "eq",
        value: `${extId}`
    });
    if (hT){
        query.addFilter({
            "type": "property",
            "id": `${definition.name}:${hT?.id}[time]`,
            "name": hT?.property ? hT?.property : "height",
            "operation": "between",
            "value": [
                dtStart,
                dtEnd
            ]
        });
    }
    // send query to dw
    const dwResults = await queryDwData(query);
    if(!dwResults) {
        return null;
    }
    const objResults = {};
    dwResults.forEach((accumulator:any) => {
        return objResults[accumulator[`${definition.name ? definition.name : 'plant' }_id`]] = accumulator;
      }, {});
    console.log("022124 Query xx dwResults ", dwResults )
    console.log("022124 Query xx objResults ", objResults )
    // transform data
    return objResults; //await parseDwResults(_plantprofileId, metric, dwResults);
}

export const queryDwLayerPigmentPropertyData = async (extId: number, definition: Definition, metric: string, dtStart: string, dtEnd: string, dwFilters:any) => {

    console.log("022124 Query xx queryDwLayerPigmentPropertyData definition", definition);

    const options = metricLut[metric];
    // create the time series query
    let query = new DwQuery(definition.id!, definition.name, definition.feature);

    query.addDimension({
        type: "entity",
        id: `${definition.name}:${definition.name}`,
        name: definition.name,
        bin: null
    });

    const pgi = getProperty(definition, ['pgi']);
    if (pgi){
        query.addMeasure({
            type: "property",
            id: `${definition.name}:${pgi?.id}`,
            name: pgi?.property ? pgi?.property : "pgi",
            stat: "mean",
            aggregation: "max"
        });
    }else{
        return null;
    }
    query.addFilter({
        type: "entity",
        id: `${definition.name}:field`,
        name: "field",
        operation: "eq",
        value: `${extId}`
    });
    if (pgi){
        query.addFilter({
            "type": "property",
            "id": `${definition.name}:${pgi?.id}[time]`,
            "name": pgi?.property ? pgi?.property : "pgi",
            "operation": "between",
            "value": [
                dtStart,
                dtEnd
            ]
        });
    }
    // send query to dw
    const dwResults = await queryDwData(query);
    if(!dwResults) {
        return null;
    }
    const objResults = {};
    dwResults.forEach((accumulator:any) => {
        return objResults[accumulator[`${definition.name ? definition.name : 'plant' }_id`]] = accumulator;
      }, {});
    console.log("022124 Query xx dwResults ", dwResults )
    console.log("022124 Query xx objResults ", objResults )
    // transform data
    return objResults; //await parseDwResults(_plantprofileId, metric, dwResults);
}

export const queryDwPointCanopyPropertyData = async (_plantprofileId: number, definition: Definition, metric: string, dtStart: string, dtEnd: string, signal: AbortSignal) => {
    // find the metric in the definition
    console.log("Query xx queryDwPointCanopyPropertyData definition", definition);

    const options = metricLut[metric];
    const entity_type = definition.name;
    const name = definition.name;

    // create the time series query
    let query = new DwQuery(definition.id!, definition.name, definition.feature);
    query.dimensions = [];
    const cA = getProperty(definition, ['canopyarea']);
    if (cA) {
        query.addMeasure({
            type: "property",
            id: `${name}:${cA?.id}`,
            name: cA?.property ? cA?.property : "canopyarea",
            source_id: ["5","10"],
        });
    }
    const cV = getProperty(definition, ['canopyvolume']);
    if (cV) {
        query.addMeasure({
            type: "property",
            id: `${name}:${cV?.id}`,
            name: cV?.property ? cV?.property : "canopyvolume",
            source_id: ["5","10"],
        });
    }
    const cPI = getProperty(definition, ['cpitotal']);
    if (cPI) {
        query.addMeasure({
            type: "property",
            id: `${name}:${cPI?.id}`,
            name: cPI?.property ? cPI?.property : "cpitotal",
            source_id: ["5","10"],
        });
    }

    query.addFilter({
        type: "entity",
        id: `${name}:${name}`,
        name: name,
        operation: "eq",
        value: `${_plantprofileId}`
    });
    if (cPI){
        query.addFilter({
            "type": "property",
            "id": `${definition.name}:${cPI?.id}[date]`,
            "name": cPI?.property ? cPI?.property : "cpitotal",
            "operation": "between",
            "value": [
                dtStart,
                dtEnd
            ]
        });
    }

    // send query to dw
    try {
        const dwResults = await queryDwDataWithCancel(query, { signal });
        if (!dwResults) {
            return null;
        }

        // transform data
        return dwResults; //await parseDwResults(_plantprofileId, metric, dwResults);
    } catch (error) {
        if (error.name === 'AbortError') {
            console.log('Query was aborted');
        } else {
            console.error('Failed to fetch data:', error);
        }
        return null;
    }
};

export const queryDwPointBBCardMaxMinDataStats = async (_fieldId: number | undefined, definition: Definition, definitionField: Definition, stat: string, dtStart: string, dtEnd: string, signal: AbortSignal) => {
    // find the metric in the definition
    console.log("080224 queryDwPointBBCardMaxMinDataStats  definition", definition);
    console.log("080224 queryDwPointBBCardMaxMinDataStats  definitionField", definitionField);
    console.log("080224 queryDwPointBBCardMaxMinDataStats  _fieldId", _fieldId);
    console.log("080224 queryDwPointBBCardMaxMinDataStats  stat", stat);
    console.log("080224 queryDwPointBBCardMaxMinDataStats  dtStart", dtStart);
    console.log("080224 queryDwPointBBCardMaxMinDataStats  dtEnd", dtEnd);
    console.log("080224 queryDwPointBBCardMaxMinDataStats  signal", signal);

    //const options = metricLut[metric];
    const entity_type = definition.name;
    const name = definition.name;
    const nameField = definitionField.name;

    // create the time series query
    let query = new DwQuery(definition.id!, definition.name, definition.feature);

    query.addDimension({
        type: "entity",
        id: `field:field`,
        name: "field",
        bin: "null"
    });

    const vvi = getProperty(definition, ['vvi']);
    console.log("080224 queryDwPointBBCardMaxMinDataStats vvi", vvi);
    if (vvi) {
        query.addMeasure({
            type: "property",
            id: `${name}:${vvi?.id}`,
            name: vvi?.property ? vvi?.property : "vvi",
            stat: "mean",
            aggregation: stat,
            source_id: ["5","10"],
        });
    }
    const pgi = getProperty(definition, ['pgi']);
    console.log("080224 queryDwPointBBCardMaxMinDataStats pgi", pgi);
    if (pgi) {
        query.addMeasure({
            type: "property",
            id: `${name}:${pgi?.id}`,
            name: pgi?.property ? pgi?.property : "pgi",
            stat: "mean",
            aggregation: stat,
            source_id: ["5","10"],
        });
    }
    const h = getProperty(definition, ['height']);
    console.log("080224 queryDwPointBBCardMaxMinDataStats  h", h);
    if (h) {
        query.addMeasure({
            type: "property",
            id: `${name}:${h?.id}`,
            name: h?.property ? h?.property : "height",
            stat: "mean",
            aggregation: stat,
            source_id: ["5","10"],
        });
    }
    /*const bi = getProperty(definition, ['bloom index']);
    console.log("080224 queryDwPointBBCardMaxMinDataStats bi", bi);
    if (bi) {
        query.addMeasure({
            type: "property",
            id: `${name}:${bi?.id}`,
            name: bi?.property ? bi?.property : "bloom index",
            stat: "mean",
            aggregation: stat,
            source_id: ["5","10"],
        });
    }
    const ca = getProperty(definition, ['canopyarea']);
    if (ca) {
        query.addMeasure({
            type: "property",
            id: `${name}:${ca?.id}`,
            name: ca?.property ? ca?.property : "canopyarea",
            stat: "mean",
            aggregation: stat,
            source_id: ["5","10"],
        });
    }*/

    query.addFilter({
        type: "entity",
        id: "field:field",
        name: "field",
        operation: "eq",
        value: `${_fieldId}`
    });
    if (vvi){
        query.addFilter({
            "type": "property",
            "id": `${definition.name}:${vvi?.id}[time]`,
            "name": vvi?.property ? vvi?.property : "vvi",
            "operation": "between",
            "value": [
                dtStart,
                dtEnd
            ]
        });
    }
    console.log("080224 queryDwPointBBCardMaxMinDataStats query", query);
    // send query to dw
    try {
        const dwResults = await queryDwDataWithCancel(query, { signal });
        if (!dwResults) {
            return null;
        }

        // transform data
        return dwResults; //await parseDwResults(_plantprofileId, metric, dwResults);
    } catch (error) {
        if (error.name === 'AbortError') {
            console.log('Query was aborted');
        } else {
            console.error('Failed to fetch data:', error);
        }
        return null;
    }
};

export const queryDwPointBBCardMaxMinDataNumberBI = async (_fieldId: number | undefined, definition: Definition, definitionField: Definition, stat: string, dtStart: string, dtEnd: string, signal: AbortSignal) => {
    // find the metric in the definition
    console.log("080224 queryDwPointBBCardMaxMinDataNumberBI  definition", definition);
    console.log("080224 queryDwPointBBCardMaxMinDataNumberBI  definitionField", definitionField);
    console.log("080224 queryDwPointBBCardMaxMinDataNumberBI  _fieldId", _fieldId);
    console.log("080224 queryDwPointBBCardMaxMinDataNumberBI  stat", stat);
    console.log("080224 queryDwPointBBCardMaxMinDataNumberBI  dtStart", dtStart);
    console.log("080224 queryDwPointBBCardMaxMinDataNumberBI  dtEnd", dtEnd);
    console.log("080224 queryDwPointBBCardMaxMinDataNumberBI  signal", signal);

    //const options = metricLut[metric];
    const entity_type = definition.name;
    const name = definition.name;
    const nameField = definitionField.name;

    // create the time series query
    let query = new DwQuery(definition.id!, definition.name, definition.feature);
    query.addDimension({
        type: "entity",
        id: "field:field",
        name: "field",
        bin: "null"
    });
    const bi = getProperty(definition, ['bloom index']);
    console.log("080224 queryDwPointBBCardMaxMinDataNumber bi", bi);
    if (bi) {
        query.addMeasure({
            type: "property",
            id: `${name}:${bi?.id}`,
            name: bi?.property ? bi?.property : "bloom index",
            stat: "mean",
            aggregation: stat,
            source_id: ["5","10"],
        });
        query.addFilter({
            type: "entity",
            id: `${nameField}:${nameField}`,
            name: nameField,
            operation: "eq",
            value: `${_fieldId}`
        });
        query.addFilter({
            "type": "property",
            "id": `${definition.name}:${bi?.id}[date]`,
            "name": bi?.property ? bi?.property : "bloom index",
            "operation": "between",
            "value": [
                dtStart,
                dtEnd
            ]
        });
        
        console.log("080224 queryDwPointBBCardMaxMinDataNumberBI query", query);
        // send query to dw
        try {
            const dwResults = await queryDwDataWithCancel(query, { signal });
            if (!dwResults) {
                return null;
            }

            // transform data
            return dwResults; //await parseDwResults(_plantprofileId, metric, dwResults);
        } catch (error) {
            if (error.name === 'AbortError') {
                console.log('Query was aborted');
            } else {
                console.error('Failed to fetch data:', error);
            }
            return null;
        }
    }else{
        return null;
    }
};

export const queryDwPointBBCardMaxMinDataNumber = async (_fieldId: number | undefined, definition: Definition, definitionField: Definition, stat: string, dtStart: string, dtEnd: string, signal: AbortSignal) => {
    // find the metric in the definition
    console.log("080224 queryDwPointBBCardMaxMinDataNumber  definition", definition);
    console.log("080224 queryDwPointBBCardMaxMinDataNumber  definitionField", definitionField);
    console.log("080224 queryDwPointBBCardMaxMinDataNumber  _fieldId", _fieldId);
    console.log("080224 queryDwPointBBCardMaxMinDataNumber  stat", stat);
    console.log("080224 queryDwPointBBCardMaxMinDataNumber  dtStart", dtStart);
    console.log("080224 queryDwPointBBCardMaxMinDataNumber  dtEnd", dtEnd);
    console.log("080224 queryDwPointBBCardMaxMinDataNumber  signal", signal);

    //const options = metricLut[metric];
    const entity_type = definition.name;
    const name = definition.name;
    const nameField = definitionField.name;

    // create the time series query
    let query = new DwQuery(definition.id!, definition.name, definition.feature);
    query.addDimension({
        type: "entity",
        id: "field:field",
        name: "field",
        bin: "null"
    });
    const ca = getProperty(definition, ['canopyarea']);
    if (ca) {
        query.addMeasure({
            type: "property",
            id: `${name}:${ca?.id}`,
            name: ca?.property ? ca?.property : "canopyarea",
            stat: "mean",
            aggregation: stat,
            source_id: ["5","10"],
        });
    }
    const cv = getProperty(definition, ['canopyvolume']);
    if (cv) {
        query.addMeasure({
            type: "property",
            id: `${name}:${cv?.id}`,
            name: cv?.property ? cv?.property : "canopyvolume",
            stat: "mean",
            aggregation: stat,
            source_id: ["5","10"],
        });
    }
    const ct = getProperty(definition, ['cpitotal']);
    if (ct) {
        query.addMeasure({
            type: "property",
            id: `${name}:${cv?.id}`,
            name: cv?.property ? cv?.property : "cpitotal",
            stat: "mean",
            aggregation: stat,
            source_id: ["5","10"],
        });
    }

    query.addFilter({
        type: "entity",
        id: `${nameField}:${nameField}`,
        name: nameField,
        operation: "eq",
        value: `${_fieldId}`
    });
    if (ca){
        query.addFilter({
            "type": "property",
            "id": `${definition.name}:${ca?.id}[date]`,
            "name": ca?.property ? ca?.property : "canopyarea",
            "operation": "between",
            "value": [
                dtStart,
                dtEnd
            ]
        });
    }
    console.log("080224 queryDwPointBBCardMaxMinDataNumber query", query);
    // send query to dw
    try {
        const dwResults = await queryDwDataWithCancel(query, { signal });
        if (!dwResults) {
            return null;
        }

        // transform data
        return dwResults; //await parseDwResults(_plantprofileId, metric, dwResults);
    } catch (error) {
        if (error.name === 'AbortError') {
            console.log('Query was aborted');
        } else {
            console.error('Failed to fetch data:', error);
        }
        return null;
    }
};

export const queryDwPointBloomData = async (_plantprofileId: number, definition: Definition, metric: string, dtStart: string, dtEnd: string, signal: AbortSignal) => {
    // find the metric in the definition
    console.log("031524 Query xx queryDwPointBloomData definition", definition);
    //if(!property) {
    //    return null;
    //}

    const entity_type = definition.name;
    const name = definition.name;
    // create the time series query
    let query = new DwQuery(definition.id!, definition.name, definition.feature);
    //query.timeSeries = true;
    //console.log("031524 definition", definition)
    query.dimensions = [];

    const bI = getProperty(definition, ['bloom index']);
    if (bI){
        query.addMeasure({
            type: "property",
            id: `${name}:${bI?.id}`,
            name: bI?.property ? bI?.property : "bloom index",
            source_id: ["5","10"],
        });
    }
    /*const bC = getProperty(definition, ['bloom count']);
    if (bC){
        query.addMeasure({
            type: "property",
            id: `${name}:${bC?.id}`,
            name: bC?.property ? bC?.property : "bloom count",
        });
    }*/

    query.addFilter({
        type: "entity",
        id: `${name}:${name}`,
        name: name,
        operation: "eq",
        value: `${_plantprofileId}`
    });
    if (bI){
        query.addFilter({
            "type": "property",
            "id": `${definition.name}:${bI?.id}[date]`,
            "name": bI?.property ? bI?.property : "bloom index",
            "operation": "between",
            "value": [
                dtStart,
                dtEnd
            ]
        });
    }
    //console.log("031524 BB card point bloom query", query)
    try {
        const dwResults = await queryDwDataWithCancel(query, { signal });
        console.log("031524 BB card point bloom dwResults", dwResults)
        if (!dwResults) {
            return null;
        }

        // transform data
        return dwResults; //await parseDwResults(_plantprofileId, metric, dwResults);
    } catch (error) {
        if (error.name === 'AbortError') {
            console.log('Query was aborted');
        } else {
            console.error('Failed to fetch data:', error);
        }
    }
}

export const queryDwPointCanopyStatsData = async (_plantprofileId: number, definition: Definition, metric: string, dtStart: string, dtEnd: string, signal:AbortSignal) => {
    // find the metric in the definition
    //const property = getProperty(definition, metricLut[metric].propLut);

    //if(!property) {
    //    return null;
    //}
    //console.log("queryDwPointCanopyStatsData");
    const options = metricLut[metric];

    // create the time series query
    let query = new DwQuery(definition.id!, definition.name, definition.feature);
    //query.timeSeries = true;
 
    query.dimensions = [];
    const vVI = getProperty(definition, ['vvi']);
    if (vVI){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${vVI?.id}`,
            "name": vVI?.property ? vVI?.property : "vvi",
            "stat": "mean",
            source_id: ["5","10"],
        });
    }
    const pGI = getProperty(definition, ['pgi'])
    if (pGI){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${pGI?.id}`,
            "name": pGI?.property ? pGI?.property : "pgi",
            "stat": "mean",
            source_id: ["5","10"],
        });
    }
    const tIR = getProperty(definition, ['tir']) 
    if (tIR){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${tIR?.id}`,
            "name": tIR?.property ? tIR?.property : "tir",
            "stat": "mean",
            source_id: ["5","10"],
        });
    }
    const h = getProperty(definition, ['height'])
    if (h){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${h?.id}`,
            "name": h?.property ? h?.property : "height",
            "stat": "mean",
            source_id: ["5","10"],
        });
    }

    query.addFilter({
        type: "entity",
        id: `${definition.name}:${definition.name}`,
        name: definition.name,
        operation: "eq",
        value: `${_plantprofileId}`
    });
    if (vVI){
        query.addFilter({
            "type": "property",
            "id": `${definition.name}:${vVI?.id}[time]`,
            "name": vVI?.property ? vVI?.property : "vvi",
            "operation": "between",
            "value": [
                dtStart,
                dtEnd
            ]
        });
    }

    console.log("BB card point canopy stats query", query)
    // send query to dw
    try {
        const dwResults = await queryDwDataWithCancel(query, { signal });
        console.log("BB card point canopy stats dwResults", dwResults)
        if (!dwResults) {
            return null;
        }

        // transform data
        return dwResults; //await parseDwResults(_plantprofileId, metric, dwResults);
    } catch (error) {
        if (error.name === 'AbortError') {
            console.log('Query was aborted');
        } else {
            console.error('Failed to fetch data:', error);
        }
    }
    // transform data
    
}

export const queryDwPointCanopyStatsDataMaxMin = async (_plantprofileId: number, definition: Definition, metric: string, dtStart: string, dtEnd: string, signal:AbortSignal) => {
    // find the metric in the definition
    //const property = getProperty(definition, metricLut[metric].propLut);

    //if(!property) {
    //    return null;
    //}
    //console.log("queryDwPointCanopyStatsData");
    const options = metricLut[metric];

    // create the time series query
    let query = new DwQuery(definition.id!, definition.name, definition.feature);
    //query.timeSeries = true;
 
    //query.dimensions = [];
    const vVI = getProperty(definition, ['vvi']);
    if (vVI){
        query.addDimension({
            type: "property",
            id: `field:${vVI?.id}`,
            name: vVI?.property ? vVI?.property : "vvi",
            bin: "year",
            stat: "time",
        });
        query.addMeasure({
            "type": "property",
            "id": `field:${vVI?.id}`,
            "name": vVI?.property ? vVI?.property : "vvi",
            "stat": "mean",
            "aggregation": "max",
            source_id: ["5","10"],
        });
        query.addMeasure({
            "type": "property",
            "id": `field:${vVI?.id}`,
            "name": vVI?.property ? vVI?.property : "vvi",
            "stat": "mean",
            "aggregation": "min",
            source_id: ["5","10"],
        });
    }
    const pGI = getProperty(definition, ['pgi'])
    if (pGI){
        query.addMeasure({
            "type": "property",
            "id": `field:${pGI?.id}`,
            "name": pGI?.property ? pGI?.property : "pgi",
            "stat": "mean",
            "aggregation": "min",
            source_id: ["5","10"],
        });
        query.addMeasure({
            "type": "property",
            "id": `field:${pGI?.id}`,
            "name": pGI?.property ? pGI?.property : "pgi",
            "stat": "mean",
            "aggregation": "min",
            source_id: ["5","10"],
        });
    }
    const tIR = getProperty(definition, ['tir']) 
    if (tIR){
        query.addMeasure({
            "type": "property",
            "id": `field:${tIR?.id}`,
            "name": tIR?.property ? tIR?.property : "tir",
            "stat": "mean",
            "aggregation": "max",
            source_id: ["5","10"],
        });
        query.addMeasure({
            "type": "property",
            "id": `field:${tIR?.id}`,
            "name": tIR?.property ? tIR?.property : "tir",
            "stat": "mean",
            "aggregation": "min",
            source_id: ["5","10"],
        });
    }
    const h = getProperty(definition, ['height'])
    if (h){
        query.addMeasure({
            "type": "property",
            "id": `field:${h?.id}`,
            "name": h?.property ? h?.property : "height",
            "stat": "mean",
            "aggregation": "max",
            source_id: ["5","10"],
        });
        query.addMeasure({
            "type": "property",
            "id": `field:${h?.id}`,
            "name": h?.property ? h?.property : "height",
            "stat": "mean",
            "aggregation": "min",
            source_id: ["5","10"],
        });
    }

    query.addFilter({
        type: "entity",
        id: `${definition.name}:${definition.name}`,
        name: definition.name,
        operation: "eq",
        value: `${_plantprofileId}`
    });
    if (vVI){
        query.addFilter({
            "type": "property",
            "id": `${definition.name}:${vVI?.id}[time]`,
            "name": vVI?.property ? vVI?.property : "vvi",
            "operation": "between",
            "value": [
                dtStart,
                dtEnd
            ]
        });
    }

    console.log("BB card point canopy stats query", query)
    // send query to dw
    try {
        const dwResults = await queryDwDataWithCancel(query, { signal });
        console.log("BB card point canopy stats dwResults", dwResults)
        if (!dwResults) {
            return null;
        }

        // transform data
        return dwResults; //await parseDwResults(_plantprofileId, metric, dwResults);
    } catch (error) {
        if (error.name === 'AbortError') {
            console.log('Query was aborted');
        } else {
            console.error('Failed to fetch data:', error);
        }
    }
    // transform data
    
}

export const queryDwPointSoilStatsData = async (_plantprofileId: number, definition: Definition, metric: string, dtStart: string, dtEnd: string, signal:AbortSignal) => {
    // find the metric in the definition
    //const property = getProperty(definition, metricLut[metric].propLut);
    console.log("BB120124 Query xx queryDwPointSoilStatsData definition", definition);
    //console.log("030823 dtStart", dtStart);
    //console.log("030823 dtEnd", dtEnd);
    //if(!property) {
    //    return null;
    //}

    const options = metricLut[metric];

    // create the time series query
    let query = new DwQuery(definition.id!, definition.name, definition.feature);
    //query.timeSeries = true;
 
    query.dimensions = [];

    const por  = getProperty(definition, ['Porosity']);
    if(por?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${por?.id}`,
            "name": por?.property ? por?.property : "Porosity",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const esp  = getProperty(definition, ['Exchangeable Sodium Percentage']);
    if(esp?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${esp?.id}`,
            "name": esp?.property ? esp?.property : "Exchangeable Sodium Percentage",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const epp  = getProperty(definition, ['Exchangeable Potassium Percentage']);
    if(epp?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${epp?.id}`,
            "name": epp?.property ? epp?.property : "Exchangeable Potassium Percentage",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const emp  = getProperty(definition, ['Exchangeable Magnesium Percentage']);
    if(emp?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${emp?.id}`,
            "name": emp?.property ? emp?.property : "Exchangeable Magnesium Percentage",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const ecp  = getProperty(definition, ['Exchangeable Calcium Percentage']);
    if(ecp?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${ecp?.id}`,
            "name": ecp?.property ? ecp?.property : "Exchangeable Calcium Percentage",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const soB  = getProperty(definition, ['Soluble Boron']);
    if(soB?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${soB?.id}`,
            "name": soB?.property ? soB?.property : "Soluble Boron",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const soS  = getProperty(definition, ['Soluble Sulfur']);
    if(soS?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${soS?.id}`,
            "name": soS?.property ? soS?.property : "Soluble Sulfur",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const sar   = getProperty(definition, ['Sodium Adsorption Ratio']);
    if(sar?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${sar?.id}`,
            "name": sar?.property ? sar?.property : "Sodium Adsorption Ratio",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const ssp   = getProperty(definition, ['Soluble Sodium Percentage']);
    if(ssp?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${ssp?.id}`,
            "name": ssp?.property ? ssp?.property : "Soluble Sodium Percentage",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const ea = getProperty(definition, ['Exchangeable Acidity']);
    if(ea?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${ea?.id}`,
            "name": ea?.property ? ea?.property : "Exchangeable Acidity",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const bs = getProperty(definition, ['Base Saturation']);
    if(bs?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${bs?.id}`,
            "name": bs?.property ? bs?.property : "Base Saturation",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const mp = getProperty(definition, ['Macroporosity']);
    if(mp?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${mp?.id}`,
            "name": mp?.property ? mp?.property : "Macroporosity",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const mc = getProperty(definition, ['Macropore Connectivity']);
    if(mc?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${mc?.id}`,
            "name": mc?.property ? mc?.property : "Macropore Connectivity",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const cu = getProperty(definition, ['Copper']);
    if(cu?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${cu?.id}`,
            "name": cu?.property ? cu?.property : "Copper",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const ecsp = getProperty(definition, ['Electrical Conductivity of Saturated Paste Extract']);
    if(ecsp?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${ecsp?.id}`,
            "name": ecsp?.property ? ecsp?.property : "Electrical Conductivity of Saturated Paste Extract",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const sp = getProperty(definition, ['Saturation Percentage']);
    if(sp?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${sp?.id}`,
            "name": sp?.property ? sp?.property : "Saturation Percentage",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const sc = getProperty(definition, ['Soluble Calcium']);
    if(sc?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${sc?.id}`,
            "name": sc?.property ? sc?.property : "Soluble Calcium",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const sm = getProperty(definition, ['Soluble Magnesium']);
    if(sm?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${sm?.id}`,
            "name": sm?.property ? sm?.property : "Soluble Magnesium",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const sk = getProperty(definition, ['Soluble Potassium']);
    if(sk?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${sk?.id}`,
            "name": sk?.property ? sk?.property : "Soluble Potassium",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const ss = getProperty(definition, ['Soluble Sodium']);
    if(ss?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${ss?.id}`,
            "name": ss?.property ? ss?.property : "Soluble Sodium",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const sss = getProperty(definition, ['Soluble Salts']);
    if(sss?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${sss?.id}`,
            "name": sss?.property ? sss?.property : "Soluble Salts",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const bd = getProperty(definition, ['bd']);
    if(bd?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${bd?.id}`,
            "name": bd?.property ? bd?.property : "bd",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const om = getProperty(definition, ['organic matter']);
    if(bd?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${om?.id}`,
            "name": om?.property ? om?.property : "om",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const z = getProperty(definition, ['zinc']);
    if(z?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${z?.id}`,
            "name": z?.property ? z?.property : "zinc",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const i = getProperty(definition, ['iron']);
    if(i?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${i?.id}`,
            "name": i?.property ? i?.property : "iron", 
            "stat": "mean",
            source_id: ["5","10"],
        });
    }
    const m = getProperty(definition, ['manganese']);
    if(m?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${m?.id}`,
            "name": m?.property ? m?.property : "manganese",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const b = getProperty(definition, ['boron']);
    if(b?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${b?.id}`,
            "name": b?.property ? b?.property : "boron",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }

    // Saturation: CEC, K-pct, Ca-pct, Na-pct, H-pct, Al-pct, NH4-pct
    const cec = getProperty(definition, ['cec']);
    if(cec?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${cec?.id}`,
            "name": cec?.property ? cec?.property : "cec",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const pS = getProperty(definition, ['phosphorus saturation']);
    if(pS?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${pS?.id}`,
            "name": pS?.property ? pS?.property : "phosphorus saturation",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const kS = getProperty(definition, ['potassium saturation']);
    if(kS?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${kS?.id}`,
            "name": kS?.property ? kS?.property : "potassium saturation",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const naS = getProperty(definition, ['sodium saturation']);
    if(naS?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${naS?.id}`,
            "name": naS?.property ? naS?.property : "sodium saturation",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const mS = getProperty(definition, ['magnesium saturation']);
    if(mS?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${mS?.id}`,
            "name": mS?.property ? mS?.property : "magnesium saturation",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const cS = getProperty(definition, ['calcium saturation']);
    if(cS?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${cS?.id}`,
            "name": cS?.property ? cS?.property : "calcium saturation",
            "stat": "mean",
            source_id: ["5","10"],
        }); 
    }
    const sS = getProperty(definition, ['sulfur saturation']);
    if(sS?.id){
        query.addMeasure({
                "type": "property",
                "id": `${definition.name}:${sS?.id}`,
                "name": sS?.property ? sS?.property : "sulfur saturation",
                "stat": "mean",
                source_id: ["5","10"],
        }); 
    }
    const hS = getProperty(definition, ['hydrogen saturation']);
    if(hS?.id){
        query.addMeasure({
                "type": "property",
                "id": `${definition.name}:${hS?.id}`,
                "name": hS?.property ? hS?.property : "hydrogen saturation",
                "stat": "mean",
                source_id: ["5","10"],
        }); 
    }
    /*  Doesnt exist?
    query.addMeasure({
        "type": "property",
        "id": `${definition.name}:${getProperty(definition, ['aluminum'])?.id}`,
        "name": "Aluminum",
        "stat": "mean"
    });  
    

    query.addMeasure({
        "type": "property",
        "id": `${definition.name}:${getProperty(definition, ['ammonium'])?.id}`,
        "name": "Ammonium",
        "stat": "mean"
    });
    */

    // Fertility
    //console.log("F112023 definition", definition)
    const sF = getProperty(definition, ['Sulfur']);
    //console.log("F112023 sF", sF)
    if(sF?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${sF?.id}`,
            "name": sF?.property ? sF?.property : "Sulfur",
            "stat": "mean",
            source_id: ["5","10"],
        });
    }
    const oM = getProperty(definition, ['organic matter']);
    if(oM?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${oM?.id}`,
            "name": oM?.property ? oM?.property : "organic matter",
            "stat": "mean",
            source_id: ["5","10"],
        });
    }
    const pAW = getProperty(definition, ['paw']);
    if(pAW?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${pAW?.id}`,
            "name": pAW?.property ? pAW?.property : "paw",
            "stat": "mean",
            source_id: ["5","10"],
        });
    }
    const pAWC = getProperty(definition, ['pawc']);
    if(pAWC?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${pAWC?.id}`,
            "name": pAWC?.property ? pAWC?.property : "pawc",
            "stat": "mean",
            source_id: ["5","10"],
        });
    }
    const kSAT = getProperty(definition, ['ksat']);
    if(kSAT?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${kSAT?.id}`,
            "name": kSAT?.property ? kSAT?.property : "ksat",
            "stat": "mean",
            source_id: ["5","10"],
        });
    }
    const pWP = getProperty(definition, ['pwp']);
    if(pWP?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${pWP?.id}`,
            "name": pWP?.property ? pWP?.property : "pwp",
            "stat": "mean",
            source_id: ["5","10"],
        });
    }
    const mO = getProperty(definition, ['moisture']);
    if(mO?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${mO?.id}`,
            "name": mO?.property ? mO?.property : "moisture",
            "stat": "mean",
            source_id: ["5","10"],
        });
    }
    /*if(){
        query.addMeasure({
            "type": "property",
            "id": `plant:${getProperty(definition, ['moisture'])?.id}`,
            "name": "Moisture",
            "stat": "max"
        });
    }*/
    //console.log("030823 definition", definition)
    const sA = getProperty(definition, ['saturation']);
    if(sA?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${sA?.id}`,
            "name": sA?.property ? sA?.property : "saturation",
            "stat": "mean",
            source_id: ["5","10"],
        });
    }
    const fC = getProperty(definition, ['fc']);
    if(fC?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${fC?.id}`,
            "name": "FC",
            "stat": "mean",
            source_id: ["5","10"],
        });
    }
    const nT = getProperty(definition, ['nitrogen']);
    if(nT?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${nT?.id}`,
            "name": nT?.property ? nT?.property : "nitrogen",
            "stat": "mean",
            source_id: ["5","10"],
        });
    }
    const mG = getProperty(definition, ['magnesium']);
    if(mG?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${mG?.id}`,
            "name": mG?.property ? mG?.property : "magnesium",
            "stat": "mean",
            source_id: ["5","10"],
        });
    }
    const pHS = getProperty(definition, ['phosphorus']);
    if(pHS?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${pHS?.id}`,
            "name": pHS?.property ? pHS?.property : "phosphorus",
            "stat": "mean",
            source_id: ["5","10"],
        });
    }
    const pT = getProperty(definition, ['potassium']);
    if(pT?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${pT?.id}`,
            "name": pT?.property ? pT?.property : "potassium",
            "stat": "mean",
            source_id: ["5","10"],
        });
    }
    const cA = getProperty(definition, ['calcium']);
    if(cA?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${cA?.id}`,
            "name": cA?.property ? cA?.property : "calcium",
            "stat": "mean",
            source_id: ["5","10"],
        });
    }
    const pH = getProperty(definition, ['ph']);
    if(pH?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${pH?.id}`,
            "name": pH?.property ? pH?.property : "ph",
            "stat": "mean",
            source_id: ["5","10"],
        });
    }
    query.addFilter({
        type: "entity",
        id: `${definition.name}:${definition.name}`,
        name: definition.name,
        operation: "eq",
        value: `${_plantprofileId}`
    });
    if (pAW?.id) {
        query.addFilter({
            "type": "property",
            "id": `${definition.name}:${pAW?.id}[time]`,
            "name": pAW?.property ? pAW?.property : "paw",
            "operation": "between",
            "value": [
                dtStart, 
                dtEnd 
            ]
        });
    }

    console.log("112124 BB card point soil stats query", query)
    // send query to dw
    try {
        const dwResults = await queryDwDataWithCancel(query, { signal });
        console.log("112124 BB card point soil stats dwResults", dwResults)
        if (!dwResults) {
            return null;
        }

        // transform data
        return dwResults; //await parseDwResults(_plantprofileId, metric, dwResults);
    } catch (error) {
        if (error.name === 'AbortError') {
            console.log('112124 Query was aborted');
        } else {
            console.error('112124 Failed to fetch data:', error);
        }
    }
}

export const queryDwPointSoilDRLData = async (_plantprofileId: number, definition: Definition, metric: string, dtStart: string, dtEnd: string, signal:AbortSignal) => {
    // find the metric in the definition
    //const property = getProperty(definition, metricLut[metric].propLut);
    console.log("Query xx queryDwPointSoilDRLData definition", definition);
    //if(!property) {
    //    return null;
    //}

    const options = metricLut[metric];

    // create the time series query
    let query = new DwQuery(definition.id!, definition.name, definition.feature);
    //query.timeSeries = true;
 
    query.dimensions = [];
    const dRL = getProperty(definition, ['drl']);
    if(dRL?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${dRL?.id}`,
            "name": dRL?.property ? dRL?.property : "drl",
            "stat": "mean",
            source_id: ["5","10"],
        });
    }
    const rLM = getProperty(definition, ['root limited moisture']);
    if (rLM?.id) {
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${rLM?.id}`,
            "name": rLM?.property ? rLM?.property : "root limited moisture",
            "stat": "mean",
            source_id: ["5","10"],
        });
    }

    query.addFilter({
        type: "entity",
        id: `${definition.name}:${definition.name}`,
        name: definition.name,
        operation: "eq",
        value: `${_plantprofileId}`
    });

    console.log("BB card point soil drl query", query)
    // send query to dw
    try {
        const dwResults = await queryDwDataWithCancel(query, { signal });
        console.log("BB card point soil drl dwResults", dwResults)
        if (!dwResults) {
            return null;
        }

        // transform data
        return dwResults; //await parseDwResults(_plantprofileId, metric, dwResults);
    } catch (error) {
        if (error.name === 'AbortError') {
            console.log('Query was aborted');
        } else {
            console.error('Failed to fetch data:', error);
        }
    }
}

export const queryDwPointCultivarStatus = async (_plantprofileId: number, definition: Definition, metric: string, dtStart: string, dtEnd: string, signal:AbortSignal) => {

    console.log("F112923 Query xx queryDwPointCultivarStatus definition", definition);

    let query = new DwQuery(definition.id!, definition.name, definition.feature);
 
    query.dimensions = [];
    const st = getProperty(definition, ['status']);
    if(st?.id){
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${st?.id}`,
            "name": st?.property ? st?.property : "status",
            source_id: ["5","10"],
        });
    }
    const cv = getProperty(definition, ['cultivar']);
    if (cv?.id) {
        query.addMeasure({
            "type": "property",
            "id": `${definition.name}:${cv?.id}`,
            "name": cv?.property ? cv?.property : "cultivar",
            source_id: ["5","10"],
        });
    }

    query.addFilter({
        type: "entity",
        id: `${definition.name}:${definition.name}`,
        name: definition.name,
        operation: "eq",
        value: `${_plantprofileId}`
    });

    console.log("BB card point cultivar status query", query)
    // send query to dw
    try {
        const dwResults = await queryDwDataWithCancel(query, { signal });
        console.log("BB card point cultivar status dwResults", dwResults)
        if (!dwResults) {
            return null;
        }

        // transform data
        return dwResults; //await parseDwResults(_plantprofileId, metric, dwResults);
    } catch (error) {
        if (error.name === 'AbortError') {
            console.log('Query was aborted');
        } else {
            console.error('Failed to fetch data:', error);
        }
    }
}

export const queryDwMetric = async (extId: number, definition: Definition, metric: string, dtStart: string, dtEnd: string) => {
    // find the metric in the definition
    console.log("queryDwMetric")
    console.log("EE121124 queryDwMetric definition", definition);
    console.log("EE121124 queryDwMetric extId", extId);
    console.log("EE121124 queryDwMetric metric", metric);
    console.log("EE121124 queryDwMetric dtStart", dtStart);
    console.log("EE121124 queryDwMetric dtEnd", dtEnd);
    const property = getProperty(definition, metricLut[metric].propLut);
    console.log("EE121124 queryDwMetric property", property);
    if(!property) {
        return null;
    }

    const options = metricLut[metric];

    // create the time series query
    let query = new DwQuery(definition.id!, definition.name, definition.feature);
    query.timeSeries = true;

    query.addDimension({
        type: "entity",
        id: "field:field",
        name: "field",
        bin: null
    });

    query.addDimension({
        type: "property",
        id: `field:${property.id}`,
        name: metric,
        stat: "time",
        bin: "date"
    });

    query.addMeasure({
        type: "property",
        id: `field:${property.id}`,
        stat: "mean",
        name: metric,
        aggregation: "avg",
        source_id: ["2"],
    });

    query.addFilter({
        type: "entity",
        id: "field:field",
        name: "field",
        operation: "eq",
        value: `${extId}`
    });

    if(options.filterMinValue) {
        query.addFilter({
            type: "property",
            id: `field:${property.id}[mean]`,
            name: metric,
            operation: "gte",
            value: options.filterMinValue
        });
    }

    if(options.filterMaxValue) {
        query.addFilter({
            type: "property",
            id: `field:${property.id}[mean]`,
            name: metric,
            operation: "lte",
            value: options.filterMaxValue
        });
    }

    query.addFilter({
        type: "property",
        id: `field:${property.id}[time]`,
        name: metric,
        operation: "gte",
        value: [dtStart]
    });

    query.addFilter({
        type: "property",
        id: `field:${property.id}[time]`,
        name: metric,
        operation: "lte",
        value: [dtEnd]
    });


    // send query to dw
    console.log("EE121124 query", query)
    const dwResults = await queryDwData(query);
    console.log("EE121124 dwResults", dwResults)
    if(!dwResults) {
        return null;
    }

    // transform data
    console.log("EE121124 parseDwResults(extId, metric, dwResults)", parseDwResults(extId, metric, dwResults))
    return await parseDwResults(extId, metric, dwResults);
}

export const queryDwZoneMetric = async (extId: number, definition: Definition, metric: string, dtStart: string, dtEnd: string, selectedZoneSetId:string | null, ) => {
    // find the metric in the definition
    console.log("D032924 queryDwZoneMetric");

    const property = getProperty(definition, metricLut[metric].propLut);
    console.log("D032924 property", property);
    if(!property) {
        return null;
    }

    const options = metricLut[metric];
    console.log("D032924 options", options);
    // create the time series query
    let query = new DwQuery(definition.id!, definition.name, definition.feature);
    query.entity="zone";
    query.timeSeries = true;

    query.addDimension({
        type: "entity",
        id: "zone:zone",
        name: "zone",
        bin: null
    });

    query.addDimension({
        type: "property",
        id: `zone:${property.id}`,
        name: metric,
        stat: "time",
        bin: "date"
    });

    query.addMeasure({
        type: "property",
        id: `zone:${property.id}`,
        stat: "mean",
        name: metric,
        aggregation: "avg",
        source_id: ["2"],
    });

    query.addFilter({
        type: "entity",
        id: "zone:zoneset",
        name: "zoneset",
        operation: "eq",
        value: `${selectedZoneSetId}`
    });

    if(options.filterMinValue) {
        query.addFilter({
            type: "property",
            id: `zone:${property.id}[mean]`,
            name: metric,
            operation: "gte",
            value: options.filterMinValue
        });
    }

    if(options.filterMaxValue) {
        query.addFilter({
            type: "property",
            id: `zone:${property.id}[mean]`,
            name: metric,
            operation: "lte",
            value: options.filterMaxValue
        });
    }

    query.addFilter({
        type: "property",
        id: `zone:${property.id}[time]`,
        name: metric,
        operation: "gte",
        value: [dtStart]
    });

    query.addFilter({
        type: "property",
        id: `zone:${property.id}[time]`,
        name: metric,
        operation: "lte",
        value: [dtEnd]
    });


    // send query to dw
    console.log("B032924 query", query)
    const dwResults = await queryDwData(query);
    console.log("B032924 dwResults", dwResults)
    if(!dwResults) {
        return null;
    }

    // transform data
    //console.log("B032924 parseDwResults(extId, metric, dwResults)", parseDwResults(extId, metric, dwResults))
    return await parseDwZoneResults(extId, metric, dwResults, "");
}

export const queryDwZoneVVIcVariance = async (extId: number, definition: Definition, metric: string, dtStart: string, dtEnd: string, selectedZoneSetId:string | null, ) => {
    // find the metric in the definition
    console.log("D051524 queryDwZoneVVIcVariance extId", extId, "definition", definition, "metric", metric, "dtStart", dtStart, "dtEnd", dtEnd);

    const property = getProperty(definition, metricLut[metric].propLut);
    console.log("C040124", property);
    if(!property) {
        return null;
    }

    const options = metricLut[metric];
    console.log("C040124 options", options);
    // create the time series query
    let query = new DwQuery(definition.id!, definition.name, definition.feature);
    query.entity="zone";
    query.timeSeries = true;

    query.addDimension({
        type: "entity",
        id: "zone:zone",
        name: "zone",
        bin: null
    });

    query.addDimension({
        type: "property",
        id: `zone:${property.id}`,
        name: metric,
        stat: "time",
        bin: "date"
    });

    query.addMeasure({
        type: "property",
        id: `zone:${property.id}`,
        stat: "stdev",//"variance",
        name: metric,
        aggregation: "avg",
        source_id: ["2"],
    });

    query.addFilter({
        type: "entity",
        id: "zone:zoneset",
        name: "zoneset",
        operation: "eq",
        value: `${selectedZoneSetId}`
    });

    if(options.filterMinValue) {
        query.addFilter({
            type: "property",
            id: `zone:${property.id}[mean]`,
            name: metric,
            operation: "gte",
            value: options.filterMinValue
        });
    }

    if(options.filterMaxValue) {
        query.addFilter({
            type: "property",
            id: `zone:${property.id}[mean]`,
            name: metric,
            operation: "lte",
            value: options.filterMaxValue
        });
    }

    query.addFilter({
        type: "property",
        id: `zone:${property.id}[time]`,
        name: metric,
        operation: "gte",
        value: [dtStart]
    });

    query.addFilter({
        type: "property",
        id: `zone:${property.id}[time]`,
        name: metric,
        operation: "lte",
        value: [dtEnd]
    });


    // send query to dw
    console.log("C040124 query", query)
    const dwResults = await queryDwData(query);
    console.log("C040124 dwResults", dwResults)
    if(!dwResults) {
        return null;
    }

    // transform data
    console.log("C040124 parseDwResults(extId, metric, dwResults)", parseDwResults(extId, metric, dwResults))
    console.log("BB051524 dwResults", dwResults);
    return await parseDwZoneResults(extId, metric, dwResults, "stdev");
}

export const queryDwFieldVVIcVariance = async (
    extId: number, 
    definition: Definition, 
    metric: string, 
    dtStart: string, 
    dtEnd: string ) => {
    // find the metric in the definition
    console.log("FF051524 queryDwFieldVVIcVariance extId", extId, "definition", definition, "metric", metric, "dtStart", dtStart, "dtEnd", dtEnd);

    const property = getProperty(definition, metricLut[metric].propLut);
    console.log("C040124", property);
    if(!property) {
        return null;
    }

    const options = metricLut[metric];
    console.log("C040124 options", options);
    // create the time series query
    let query = new DwQuery(definition.id!, definition.name, definition.feature);
    //query.entity="zone";
    query.timeSeries = true;

    query.addDimension({
        type: "entity",
        id: "field:field",
        name: "field",
        bin: null
    });

    query.addDimension({
        type: "property",
        id: `field:${property.id}`,
        name: metric,
        stat: "time",
        bin: "date"
    });

    query.addMeasure({
        type: "property",
        id: `field:${property.id}`,
        stat: "stdev",//"variance",
        name: metric,
        aggregation: "avg"
    });

    query.addFilter({
        type: "entity",
        id: "field:field",
        name: "field",
        operation: "eq",
        value: `${extId}`
    });

    if(options.filterMinValue) {
        query.addFilter({
            type: "property",
            id: `field:${property.id}[mean]`,
            name: metric,
            operation: "gte",
            value: options.filterMinValue
        });
    }

    if(options.filterMaxValue) {
        query.addFilter({
            type: "property",
            id: `field:${property.id}[mean]`,
            name: metric,
            operation: "lte",
            value: options.filterMaxValue
        });
    }

    query.addFilter({
        type: "property",
        id: `field:${property.id}[time]`,
        name: metric,
        operation: "gte",
        value: [dtStart]
    });

    query.addFilter({
        type: "property",
        id: `field:${property.id}[time]`,
        name: metric,
        operation: "lte",
        value: [dtEnd]
    });


    // send query to dw
    console.log("C040124 query", query)
    const dwResults = await queryDwData(query);
    console.log("FF051524 dwResults", dwResults)
    if(!dwResults) {
        return null;
    }

    // transform data
    //console.log("C040124 parseDwResults(extId, metric, dwResults)", parseDwResults(extId, metric, dwResults))
    return await parseDwFieldResults(extId, metric, dwResults, "stdev");
}

export const queryDwFieldChange = async (extId: number, definition: Definition, metric: string, dtStart: string, dtEnd: string ) => {
    // find the metric in the definition
    console.log("D051524 queryDwFieldChange extId", extId, "definition", definition, "metric", metric, "dtStart", dtStart, "dtEnd", dtEnd);

    const property = getProperty(definition, metricLut[metric].propLut);
    console.log("C040124", property);
    if(!property) {
        return null;
    }

    const options = metricLut[metric];
    console.log("C040124 options", options);
    // create the time series query
    let query = new DwQuery(definition.id!, definition.name, definition.feature);
    //query.entity="zone";
    query.timeSeries = true;
    query.timeSeriesFunction = "ChangeRates";
    query.addDimension({
        type: "entity",
        id: "field:field",
        name: "field",
        bin: null
    });

    query.addDimension({
        type: "property",
        id: `field:${property.id}`,
        name: metric,
        stat: "time",
        bin: "date"
    });

    query.addMeasure({
        type: "property",
        id: `field:${property.id}`,
        stat: "stdev", //"variance",
        name: metric,
        aggregation: "avg",
        source_id: ["2"],
    });

    query.addFilter({
        type: "entity",
        id: "field:field",
        name: "field",
        operation: "eq",
        value: `${extId}`
    });

    if(options.filterMinValue) {
        query.addFilter({
            type: "property",
            id: `field:${property.id}[mean]`,
            name: metric,
            operation: "gte",
            value: options.filterMinValue
        });
    }

    if(options.filterMaxValue) {
        query.addFilter({
            type: "property",
            id: `field:${property.id}[mean]`,
            name: metric,
            operation: "lte",
            value: options.filterMaxValue
        });
    }

    query.addFilter({
        type: "property",
        id: `field:${property.id}[time]`,
        name: metric,
        operation: "gte",
        value: [dtStart]
    });

    query.addFilter({
        type: "property",
        id: `field:${property.id}[time]`,
        name: metric,
        operation: "lte",
        value: [dtEnd]
    });


    // send query to dw
    console.log("C040124 query", query)
    const dwResults = await queryDwData(query);
    console.log("FF051524 dwResults", dwResults)
    if(!dwResults) {
        return null;
    }

    // transform data
    console.log("C040124 parseDwResults(extId, metric, dwResults)", parseDwResults(extId, metric, dwResults))
    return await parseDwFieldResults(extId, metric, dwResults, "stdev_rate");
}

export const queryDwZoneChange = async (extId: number, definition: Definition, metric: string, dtStart: string, dtEnd: string, selectedZoneSetId:string | null, ) => {
    // find the metric in the definition
    console.log("D051525 queryDwZoneChange extId", extId, "definition", definition, "metric", metric, "dtStart", dtStart, "dtEnd", dtEnd, "selectedZoneSetId", selectedZoneSetId);

    const property = getProperty(definition, metricLut[metric].propLut);
    console.log("C040124", property);
    if(!property) {
        return null;
    }

    const options = metricLut[metric];
    console.log("C040124 options", options);
    // create the time series query
    let query = new DwQuery(definition.id!, definition.name, definition.feature);
    query.entity="zone";
    query.timeSeries = true;
    query.timeSeriesFunction = "ChangeRates";
    query.addDimension({
        type: "entity",
        id: "zone:zone",
        name: "zone",
        bin: null
    });

    query.addDimension({
        type: "property",
        id: `zone:${property.id}`,
        name: metric,
        stat: "time",
        bin: "date"
    });

    query.addMeasure({
        type: "property",
        id: `zone:${property.id}`,
        stat: "stdev", //"variance",
        name: metric,
        aggregation: "avg",
        source_id: ["2"],
    });

    query.addFilter({
        type: "entity",
        id: "zone:zoneset",
        name: "zoneset",
        operation: "eq",
        value: `${selectedZoneSetId}`
    });

    if(options.filterMinValue) {
        query.addFilter({
            type: "property",
            id: `zone:${property.id}[mean]`,
            name: metric,
            operation: "gte",
            value: options.filterMinValue
        });
    }

    if(options.filterMaxValue) {
        query.addFilter({
            type: "property",
            id: `zone:${property.id}[mean]`,
            name: metric,
            operation: "lte",
            value: options.filterMaxValue
        });
    }

    query.addFilter({
        type: "property",
        id: `zone:${property.id}[time]`,
        name: metric,
        operation: "gte",
        value: [dtStart]
    });

    query.addFilter({
        type: "property",
        id: `zone:${property.id}[time]`,
        name: metric,
        operation: "lte",
        value: [dtEnd]
    });


    // send query to dw
    console.log("C040124 query", query)
    const dwResults = await queryDwData(query);
    console.log("C040124 dwResults", dwResults)
    if(!dwResults) {
        return null;
    }

    // transform data
    //console.log("C040124 parseDwResults(extId, metric, dwResults)", parseDwResults(extId, metric, dwResults))
    return await parseDwZoneResults(extId, metric, dwResults, "stdev_rate");
}

export const queryDwSoilMaxMin = async (extId: number, definition: Definition, layer: any, dtStart: string, dtEnd: string) => {
    // find the metric in the definition
    console.log("AA102824 queryDwSoilMaxMin")

    const property = getPropertyById(definition, layer.property_id);
    console.log("AA102824 property", property);
    console.log("AA102824 definition", definition);
    console.log("AA102824 layer.property_id", layer.property_id);
    if(!property) {
        return null;
    }

    // create the time series query
    let query = new DwQuery(definition.id!, definition.name, definition.feature);
    //query.timeSeries = true;

    /* No dimenesions
    query.addDimension({
        type: "entity",
        id: "field:field",
        name: "field",
        bin: null
    });
    */

    query.addMeasure({
        type: "property",
        id: `field:${property.id}`,
        stat: "max",
        name: layer.name,//property.name,
    });

    query.addMeasure({
        type: "property",
        id: `field:${property.id}`,
        stat: "min",
        name: layer.name, //property.name,
    });

    query.addMeasure({
        type: "property",
        id: `field:${property.id}`,
        stat: "stdev", //"max",
        name: layer.name,//property.name,
    });

    query.addMeasure({
        type: "property",
        id: `field:${property.id}`,
        stat: "mean", //"min",
        name: layer.name, //property.name,
    });

    query.addFilter({
        type: "entity",
        id: "field:field",
        name: "field",
        operation: "eq",
        value: `${extId}`
    });

    /* No date
    query.addFilter({
        type: "property",
        id: `field:${property.id}[time]`,
        name: metric,
        operation: "gte",
        value: [dtStart]
    });

    query.addFilter({
        type: "property",
        id: `field:${property.id}[time]`,
        name: metric,
        operation: "lte",
        value: [dtEnd]
    });
    */

    // send query to dw
    const dwResults = await queryDwData(query);

    if(!dwResults) {
        return null;
    }

    // transform data
    return await dwResults; //parseDwResults(extId, metric, dwResults);
}

export const getProperty = (definition: Definition | null, propLut: string[]) => {
    //console.log("definition", definition)
    //console.log("propLut", propLut)
    if(!definition) {
        return null;
    }
    for(let i = 0; i < propLut.length; i++) {
        let property = definition.property.find((p:Property) => p.property.toLowerCase() === propLut[i].toLowerCase());
        if(property) {
            return property;
        }
    }

    return null;
}

export const getPropertyById = (definition: Definition | null, propLut: number) => {
    //console.log("definition", definition)
    //console.log("propLut", propLut)
    if(!definition) {
        return null;
    }
  
    let property = definition.property.find((p:Property) => p.id === propLut);
    if(property) {
        return property;
    }
    

    return null;
}

const queryDwData = async (query: DwQuery) => {
    const api = new DwQueryClient(process.env.REACT_APP_CHATBOT_URL!);

    try {
        return await api.doQuery(query, "chart");
    } catch(e) {
        console.error(e);
    }

    return null;
}

const queryDwDataWithCancel = async (query: DwQuery, options: { signal?: AbortSignal }) => {
    const api = new DwQueryClient(process.env.REACT_APP_CHATBOT_URL!);

    try {
        return await api.doQueryWithCancel(query, "chart", options);
    } catch (e) {
        if (e.name === 'AbortError') {
            console.log('Fetch aborted');
        } else {
            console.error(e);
        }
    }

    return null;
};

const parseDwResults = async (extId: number, metric: string, data: any) => {
    if(!data.success) {
        return null;
    }
    console.log("FFF051524 parseDwResults metric", metric, data)
    const fieldData = data.rows.find((row:any) => row.field_id === extId);
    if(!fieldData) {
        return null;
    }

    const timeField = `${metric}_date`;
    const valueField = `${metric}_mean`;

    const transformer = metricLut[metric].transform;


    return {
        dates: fieldData[timeField],
        values: transformer(fieldData[valueField], data.rows, "fields")
    }
}

const parseDwZoneResults = async (extId: number, metric: string, data: any, stat:string) => {
    if(!data.success) {
        return null;
    }
    console.log("FFF051524 parseDwZoneResults metric", metric, data)
    const fieldData = data.rows.map((row:any) => {
        const timeField = `${metric}_date`;
        const valueField = `${metric}_${stat === "" ? "mean" : stat}`;

        const transformer = metricLut[metric].transform;

        return {
            zone_id: row.zone_id,
            row: row,
            dates: row[timeField],
            values: transformer(row[valueField], data.rows, "zones")
        }
    });
    return fieldData;
}
const parseDwFieldResults = async (extId: number, metric: string, data: any, stat:string) => {
    if(!data.success) {
        return null;
    }
    console.log("F051524 data", data)
    console.log("FFF051524 parseDwFieldResults metric", metric, data)
    const fieldData = data.rows.map((row:any) => {
        const timeField = `${metric}_date`;
        const valueField = `${metric}_${stat === "" ? "mean" : stat}`;

        const transformer = metricLut[metric].transform;
        console.log("F051524 row", row);
        console.log("GG051524 metric", metric);
        console.log("GG051524 valueField", valueField);
        console.log("GG051524 row[valueField]", row[valueField]);
        console.log("GG051524 transformer(row[valueField])", transformer(row[valueField]));
        return {
            zone_id: row.zone_id,
            row: row,
            dates: row[timeField],
            values: transformer(row[valueField]/*, data.rows, "fields"*/)
        }
    });
    return fieldData;
}

export const fetchData = async (path: string, query: any) => {  
    console.log("XX111723 path", path)    
    console.log("XX111723 query", query)    
    var url = `${process.env.REACT_APP_CHATBOT_URL}${path}`;

    var headers = new Headers();
    headers.append("Content-Type", "application/json");

    const token = localStorage.getItem('syncarto_jwt');
    headers.append("Authorization", token ? `Bearer ${token}` : "");

    const response = await fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(query)    
    });
    
    if (!response.ok) {
        console.log("XX111723 response", response)
        const message = `An error has occured: ${response.status}`;
        throw new Error(message);
    }

    return await response.json();
}


const queryFromTimeSeriesConfig = (definition: Definition, config: TimeSeriesStatQueryConfig, dtStart?: string, dtEnd?: string) => {
    console.log("queryFromTimeSeriesConfig")
    const property = getProperty(definition, [config.property]);

    if(!property) {
        return null;
    }

    // create the time series query
    let query = new DwQuery(definition.id!, definition.name, definition.feature);
    query.timeSeries = true;

    // dimensions
    query.addDimension({
        type: "entity",
        id: "field:field",
        name: "field",
        bin: null
    });

    query.addDimension({
        type: "property",
        id: `field:${property.id}`,
        name: config.property,
        stat: "time",
        bin: config.bin
    });

    // measure
    query.addMeasure({
        id: `field:${property.id}`,
        type: "property",
        name: config.property,
        stat: config.statistic,
        aggregation: config.summerize
    });

    // filters
    if(config.min) {
        query.addFilter({
            type: "property",
            id: `field:${property.id}[mean]`,
            name: config.property,
            operation: "gte",
            value: config.min
        });
    }

    if(config.max) {
        query.addFilter({
            type: "property",
            id: `field:${property.id}[mean]`,
            name: config.property,
            operation: "lte",
            value: config.max
        });
    }

    if(dtStart) {
        query.addFilter({
            type: "property",
            id: `field:${property.id}[time]`,
            name: config.property,
            operation: "gte",
            value: [dtStart]
        });
    }

    if(dtEnd) {
        query.addFilter({
            type: "property",
            id: `field:${property.id}[time]`,
            name: config.property,
            operation: "lte",
            value: [dtEnd]
        });
    }
    console.log("012624 queryFromTimeSeriesConfig query", query)
    return query;
}


const parseTimeSeriesQueryResults = async (definition: Definition, config: TimeSeriesStatQueryConfig, data: any) => {
    if(!data.success) {
        return null;
    }
    console.log("F062024 data", data)
    const fieldLut = new Map<number, EntityTimeSeriesResults>();

    const entityName = definition.name;
    const dataField = `${config.property}_${config.statistic}`;
    const dataDates = `${config.property}_date`;

    data.rows.map((row: any) => {
        const entityId = parseInt(row[`${entityName}_id`]);
        console.log("FF062024 row", row)
        console.log("F062024 dataField", dataField)
        console.log("F062024 dataDates", dataDates)
        if(!fieldLut.has(entityId)) {
            fieldLut.set(entityId, {
                entityId,
                results: []
            } as EntityTimeSeriesResults);
        }

        const entityResults = fieldLut.get(entityId);

        if(entityResults) {
            entityResults.results.push({
                name: config.name,
                values: config.transform(row[dataField]), 
                //values: row[dataField],
                time: row[dataDates] ? row[dataDates] : null, 
            }); 
        }
    });

    return Array.from(fieldLut).map(([key,value]) => value);
}


const getTimeSeriesResult = async (definition: Definition, config: TimeSeriesStatQueryConfig, dtStart: string, dtEnd: string) => {
    const query = queryFromTimeSeriesConfig(definition, config, dtStart, dtEnd);
    if(!query) {
        return null;
    }

    const results = await queryDwData(query);
    if(!results) {
        return null;
    }

    // transform data
    return await parseTimeSeriesQueryResults(definition, config, results);
}

export const getTimeSeriesStats = async (
    definition: Definition, 
    configs: TimeSeriesStatQueryConfig[], 
    dtStart: string,
    dtEnd: string) => {
    let entries: EntityTimeSeriesResults[] = [];

    const promises = [];

    for(const config of configs) {
        const promise = getTimeSeriesResult(definition, config, dtStart, dtEnd);
        promises.push(promise);
    };

    await Promise.all(promises).then((results) => {
        for(let i = 0; i < results.length; i++) {
            const tsResult = results[i];
            if(tsResult) {
                for(const r of tsResult) {
                    // de we already have an entry for this entity?
                    const entityResult = entries!.find((entry: EntityTimeSeriesResults) => entry.entityId === r.entityId);
                    entityResult ? entityResult.results.push(...r.results) : entries!.push(r);
                };    
            }
        }
    });

    return entries;
}
